import Contentstack from "contentstack";
import {jsonToHtml} from "@contentstack/json-rte-serializer";

const getSections = (sections) => {
    return sections?.map(section => sectionMapper(section))
        .filter(section => !!section);
}

const mapBlogSection = (data) => {
    const mappedData = {};
    mappedData.backgroundUrl = data.background_image?.url;
    mappedData.classes = data.custom_class;
    mappedData.componentName = "BlogSection";
    mappedData.itemList = data.blog_items.map(({blog_item}) => (
        {
            badgeText: blog_item.badge_text,
            badgeType: blog_item.badge_type,
            category: blog_item.category,
            description: blog_item.description,
            imageAltText: blog_item.image.title,
            imageUrl: blog_item.image.url,
            linkUrl: blog_item.linkurl.href,
            title: blog_item.linkurl.title,
        }
    ));
    mappedData.linkStyle = data.cta_style;
    mappedData.linkText = data.cta_button?.title; // TODO: To add CTA funtionality to this section
    mappedData.linkUrl = data.cta_button?.href; // TODO: To add CTA funtionality to this section
    return mappedData;
};

const mapFeaturedContentSection = (data) => {
    const mappedData = {};
    mappedData.classes = data.custom_class;
    mappedData.componentName = "FeaturedContentSection";
    mappedData.description = data.description;
    mappedData.headerTitle = data.header_title;
    mappedData.imageUrl = data.image_url?.url;
    mappedData.linkStyle = data.cta_style;
    mappedData.linkText = data.cta_button?.title; // TODO: To add CTA funtionality to this section
    mappedData.linkUrl = data.cta_button?.href; // TODO: To add CTA funtionality to this section
    mappedData.title = data.title;
    return mappedData;
};

const mapFeaturedSection = (data) => {
    const mappedData = {};
    mappedData.backgroundUrl = data.background_image?.url;
    mappedData.categoryId = data.list_category;
    mappedData.classes = data.custom_class;
    mappedData.componentName = "FeaturedSection";
    mappedData.description = data.description;
    mappedData.headerTitle = data.header_title;
    mappedData.linkStyle = data.cta_style;
    mappedData.linkText = data.cta_button?.title;
    mappedData.linkUrl = data.cta_button?.href;
    mappedData.listType = data.list_type;
    mappedData.sliderType = data.slider_type;
    mappedData.title = data.title;
    return mappedData;
};

const mapHeroSection = (data) => {
    const mappedData = {};
    mappedData.componentName = "HeroSection";
    mappedData.classes = data.custom_class;
    mappedData.imageUrl = data.image?.url;
    mappedData.linkUrl = data.linkurl?.href;
    mappedData.sliderType = "Hero";
    mappedData.title = data.linkurl.title;
    return mappedData;
};

const mapLatestEditions = (data) => {
    const mappedData = {};
    mappedData.classes = data.custom_class;
    mappedData.componentName = "LatestEditionsSection";
    mappedData.itemList = data.latest_editions_items.map(({latest_edition_item}) => (
        {
            imageUrl: latest_edition_item.image.url,
            linkUrl: latest_edition_item.linkurl.href,
            title: latest_edition_item.linkurl.title,
        }
    ));
    mappedData.linkStyle = data.cta_style;
    mappedData.linkText = data.cta_button?.title;
    mappedData.linkUrl = data.cta_button?.href;
    mappedData.sliderType = "LatestEditions";
    return mappedData;
};

const mapMultiSliderSection = (data) => {
    const mappedData = {};
    mappedData.classes = data.custom_class;
    mappedData.componentName = "MultiSliderSection",
        mappedData.itemList = data.list_category.map(({category_tab}) => ({
            categoryId: category_tab.category,
            itemList: [],
            linkStyle: category_tab.cta_style,
            linkUrl: category_tab.cta_button.href,
            linkText: category_tab.cta_button.title,
            listType: category_tab.list_type,
            sliderType: category_tab.slider_type,
            title: category_tab.tab_title,
        }));
    mappedData.title = data.title;
    return mappedData;
};

const mapSimpleSection = (data) => {
    const mappedData = {};
    mappedData.categoryId = data.list_category;
    mappedData.classes = data.custom_class;
    mappedData.componentName = "SimpleSection";
    mappedData.headerTitle = data.header_title;
    mappedData.linkStyle = data.cta_style;
    mappedData.linkText = data.cta_button?.title;
    mappedData.linkUrl = data.cta_button?.href;
    mappedData.listType = data.list_type;
    mappedData.sliderType = data.slider_type;
    mappedData.title = data.title;
    return mappedData;
};


const mapSimpleYouTubeSection = (data) => {
    const mappedData = {};
    mappedData.backgroundUrl = data.background_image?.url;
    mappedData.classes = data.custom_class;
    mappedData.componentName = "SimpleYouTubeSection";
    mappedData.headerTitle = data.header_title;
    mappedData.title = data.title;
    mappedData.description = data.description;
    mappedData.youtubeKey = data.youtube_key;
    return mappedData;
};


const mapTextOnlySection = (data) => {
    const mappedData = {};
    mappedData.backgroundUrl = data.background_image?.url;
    mappedData.classes = data.custom_class;
    mappedData.componentName = "TextOnlySection";
    mappedData.headerTitle = data.header_title;
    mappedData.title = data.title;
    mappedData.description = data.description;
    return mappedData;
};

const mapFullTextSection = (data) => {
    const mappedData = {};
    mappedData.componentName = "FullTextSection";
    mappedData.backgroundUrl = data.select_background_image?.url;
    mappedData.backgroundType = data.select_background;
    mappedData.jsonRTE = data.full_text_section
    return mappedData;
};

const mapImageContentSection = ({select_image_content}) => {
    const data = select_image_content[0]
    const mappedData = {};
    mappedData.componentName = "ImageContentSection";
    mappedData.backgroundUrl = data.background_image?.url;
    mappedData.title = data.image_link?.title;
    mappedData.linkUrl = data.image_link?.href;
    mappedData.desktopImageUrl = data.desktop_image?.url;
    mappedData.desktopImageTitle = data.desktop_image?.title;
    mappedData.mobileImageUrl = data.mobile_image?.url;
    mappedData.mobileImageTitle = data.mobile_image?.title;
    mappedData.tabletImageUrl = data.tablet_image?.url;
    mappedData.tabletImageTitle = data.tablet_image?.title;
    mappedData.backgroundType = data.select_background;
    return mappedData;
};

const sectionMethodMapper = {
    'blog_section': mapBlogSection,
    'featured_content': mapFeaturedContentSection,
    'featured_slider': mapFeaturedSection,
    'hero_section': mapHeroSection,
    'latest_editions': mapLatestEditions,
    'multi_slider': mapMultiSliderSection,
    'simple_slider': mapSimpleSection,
    'simple_youtube_section': mapSimpleYouTubeSection,
    'text_only_section': mapTextOnlySection,
    'full_text': mapFullTextSection,
    'image_content': mapImageContentSection,
};

const sectionMapper = (section) => {
    const sectionType = Object.keys(section)[0];
    const foundSection = !!sectionMethodMapper[sectionType] ?
        sectionMethodMapper[sectionType](section[sectionType]) :
        null;

    if (!foundSection)
        console.error("sectionMap not found", sectionType);

    foundSection.sectionId = _.times(8, () => _.random(35).toString(36)).join('');
    return foundSection;
};

const fetchContentStackItems = async ({path, apiKey, token, environment, contentType, content}) => {
    const cleanPath = path.split('?')[0];
    if(content && JSON.parse(content)[0]) {
        const pageData = JSON.parse(content)[0][0];

        let metadata = {};
        let pageMetadata = {};
        let keywords = {};

        if (typeof pageData.page_metadata !== 'undefined') {
            pageMetadata = pageData.page_metadata;

            if (typeof pageData.page_metadata.predefined_keyword_set !== 'undefined') {
                keywords = pageData.page_metadata.predefined_keyword_set[0]?.keywords ?? '';
            }

            metadata = {
                ...pageMetadata,
                keywords: keywords
            };
        }

        return {
            sections: getSections(pageData.modular_blocks),
            metadata
        };
    } else {
        console.log('Not using cached content.')
        const Stack = Contentstack.Stack({"api_key": apiKey, "delivery_token": token, "environment": environment});
        const Query = Stack.ContentType(contentType ?? 'landing_page_content').Query();
        return Query.where('path', cleanPath)
            .includeReference('modular_blocks.image_content.select_image_content')
            .toJSON()
            .find()
            .then((result) => {
                const pageData = result[0][0];

                let metadata = {};
                let pageMetadata = {};
                let keywords = {};

                if (typeof pageData.page_metadata !== 'undefined') {
                    pageMetadata = pageData.page_metadata;

                    if (typeof pageData.page_metadata.predefined_keyword_set !== 'undefined') {
                        keywords = pageData.page_metadata.predefined_keyword_set[0]?.keywords ?? '';
                    }

                    metadata = {
                        ...pageMetadata,
                        keywords: keywords
                    };
                }

                return {
                    sections: getSections(pageData.modular_blocks),
                    metadata
                };
            })
            .catch((error) => {
                console.log("contentstack query error:", error);
            });
    }
}

export {
    getSections,
    sectionMapper,
    fetchContentStackItems
}
